var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import moment from 'moment';
import Component from 'vue-class-component';
import HeaderItem from "../../../components/HeaderItem";
import UploadDialog from './UploadDialog.vue';
import { Prop, Watch } from 'vue-property-decorator';
import QuotedPrice from "../../../api/QuotedPrice";
import EQuotedPriceType from '../../../enum/EQuotedPriceType';
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';
import { setTreeChildrenDisable } from "../../../helper/util";
import EHanldeStatus from '../../../enum/EHandleStatus';
import _ from 'lodash';
var limit = moment(moment(Date.now()).subtract(1, 'year')).valueOf();
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cacheData = {};
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < limit - 8.64e7;
            }
        };
        _this.uploadDialogVisible = false;
        _this.typeEnum = EQuotedPriceType;
        _this.categoryData = [];
        _this.orderTree = [];
        _this.isRequireds = [];
        return _this;
    }
    default_1.prototype.watchClient = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        this.treeChange();
        this.updateIsRequired();
    };
    default_1.prototype.watchOrder = function () {
        this.orderChange();
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.value,
            label: node.name + ("" + (node.is_used_to === 1 ? '（常用）' : '')),
            children: node.children,
        };
    };
    default_1.prototype.loadOptions = function (_a) {
        var _this = this;
        var action = _a.action, parentNode = _a.parentNode, callback = _a.callback;
        if (action === LOAD_CHILDREN_OPTIONS) {
            this.service.getAgent({ business_id: parentNode.business_id, order_type: this.priceType }).then(function (res) {
                var children = res.data.data || [];
                children.forEach(function (item) {
                    item.supplier_to_business_id = parentNode.value;
                    item.business_id = parentNode.business_id;
                    item.tempId = item.value;
                    item.value = item.value + "&$" + parentNode.value + "&$" + item.name + "&$" + parentNode.is_show_quotation_current_price + "&$" + parentNode.business_id;
                });
                parentNode.children = children;
                if (children.length) {
                    parentNode.isDisabled = false;
                }
                callback();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                callback();
            });
        }
    };
    default_1.prototype.orderChange = function () {
        this.$emit("order-change", this.formData);
        this.getOrderList();
    };
    default_1.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
    };
    default_1.prototype.treeChange = function () {
        if (!this.formData.client.length) {
            this.formData.order_code = [];
        }
        this.$emit('client-change', this.formData);
        this.getOrderList();
    };
    default_1.prototype.getOrderList = function () {
        var _this = this;
        if (this.priceType === EQuotedPriceType.Common) {
            return;
        }
        var business_id = _.uniqBy(this.formData.clientArray, "business_id").map(function (item) { return item.business_id; });
        var supplier_to_business_id = _.uniqBy(this.formData.clientArray, "supplier_to_business_id").map(function (item) { return item.supplier_to_business_id; });
        var expiry_start = this.formData.s_time;
        if (!business_id.length) {
            this.orderTree = [];
            return;
        }
        this.service.getRelationCode(business_id.join(","), supplier_to_business_id.join(","), expiry_start.format('yyyy-MM-dd')).then(function (res) {
            setTreeChildrenDisable(res.data.data);
            _this.orderTree = res.data.data || [];
        });
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        this.service.getBusiness().then(function (res) {
            res.data.data.forEach(function (item) {
                item.children = null;
                item.isDisabled = true;
            });
            _this.categoryData = res.data.data;
            _this.isRequireds = _this.categoryData.filter(function (item) { return item.is_qi_must_upload_enclosure === 1; }).map(function (item) { return item.value; });
        });
    };
    default_1.prototype.clientClick = function (parentNode) {
        console.dir(parentNode, 250);
        this.$refs.businessTree.loadChildrenOptions(parentNode);
        parentNode.isExpanded = true;
    };
    default_1.prototype.openUploadDialog = function () {
        this.uploadDialogVisible = !this.uploadDialogVisible;
    };
    default_1.prototype.handleFileChange = function (fileList) {
        this.formData.fileListData = fileList.length > 0 ? fileList : [];
    };
    default_1.prototype.updateIsRequired = function () {
        var isRequiredSet = new Set(this.isRequireds);
        this.formData.is_qi_must_upload_enclosure = this.formData.client.some(function (item) {
            var valueParts = item.split("&$");
            if (valueParts.length > 2) {
                var requiredValue = Number(valueParts[1]);
                if (isRequiredSet.has(requiredValue)) {
                    return true;
                }
            }
            return false;
        }) ? 1 : 0;
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "priceType", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "fromSystem", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch("formData.client")
    ], default_1.prototype, "watchClient", null);
    __decorate([
        Watch("formData.order_code")
    ], default_1.prototype, "watchOrder", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                UploadDialog: UploadDialog
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
